import type { BadgeVariant } from '@/components/ui/Badge';
import type { AdminOfferStatus } from '@/lib/types/admin-partner-offer';

/**
 * The badge tone for each offer lifecycle state, shared by the partner's own
 * Perks & Offers console and the admin offers console.
 *
 * WHY SHARED. These are the same six states on the same rows, and a partner
 * and an admin talking about one offer on a support call must not be looking
 * at two different colours for it. Both consoles previously kept their own
 * copy, and they had already drifted: `draft` and `inactive` were `chip` on
 * the partner side and `neutral` on the admin side, under an admin-side
 * comment claiming the two matched.
 *
 * Tones come from Figma node 322:6281 (the partner console, the only one with
 * a design): Live is `teal` (#2B958E), Accepted is `success`, Submitted is
 * `warning`, Rejected is `danger`, Draft and Inactive are `chip`.
 *
 * LABELS ARE DELIBERATELY NOT SHARED. The partner reads "Submitted" (they
 * submitted it); the admin reads "Awaiting review" (it is waiting on them).
 * Same state, two audiences, two correct words - see each console's own
 * `OFFER_STATUS_LABEL`.
 */
export const OFFER_STATUS_BADGE_VARIANT: Record<AdminOfferStatus, BadgeVariant> = {
  draft: 'chip',
  submitted: 'warning',
  accepted: 'success',
  rejected: 'danger',
  live: 'teal',
  inactive: 'chip',
};
